
import { FreeBlock } from "@/utils/documents/free-block";
import AppSelectPlacement from "./SelectPlacement.vue";
import Vue from "vue";
import { DocumentLayoutLogoPosition } from "@/utils/documents/layout-logo";
import AppFieldsEdit from "./FieldsEdit.vue";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import AppConditionsEditModal from "@/components/layout-editor/ConditionsEditModal.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleInSaleLayoutPropSelectGroup } from "@/utils/prop-select/sale-in-sale-layout-prop-group";

export default Vue.extend({
	data(){
		return {
			name: "",
			editConditionsOpen: false
		};
	},
	props: {
		value: {
			type: Object as ()=>FreeBlock,
			required: true
		},
		index: {
			type: Number,
			required: true
		},
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		}
	},
	computed: {
		conditionProps():PropSelectGroup{
			return getSaleInSaleLayoutPropSelectGroup();
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.name = this.value.getName(this.index);
			}
		}
	},
	methods: {
		setPlacement(value:DocumentLayoutLogoPosition){
			this.value.Placement = value;
			this.value.X = 0;
			this.value.Y = 0;
		},
		onNameInput(input:string){
			this.name = input;
			this.value.Name = this.name;
		}
	},
	components: {
		AppFieldsEdit,
		AppSelectPlacement,
		AppConditionsEditModal
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
